export default __webpack_public_path__ + "static/media/Flutter_Hello_World_App.5dcc9c6e.png";